import React from 'react';
import PropTypes from 'prop-types';
import { t, defineMessages } from '@sm/intl';
import './page-header.scss';

const DEFAULT_COPY = defineMessages({
  PAGE: {
    id: 'PageHeader.Page',
    defaultMessage: 'Page',
    description: '[Type: Text][Vis.: low] - Page Text',
  },
});

const PageHeader = ({ currentPage, totalPages }) => (
  <h4 className="sm-page-header--heading" data-testid="PageHeader__Container">
    <hr className="sm-page-header--separator" />
    <div className="sm-page-header--count">
      {t(DEFAULT_COPY.PAGE)} {currentPage}/{totalPages}
    </div>
  </h4>
);

PageHeader.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

export default PageHeader;
